export enum ClassName {
  ADJUSTED_DIALOG = 'adjusted-dialog',
  HIGHER_DIALOG = 'higher-modal',
  NO_PADDING_DIALOG = 'modal-no-padding',
  UNCLOSABLE_DIALOG = 'unclosable-dialog',
}
